<template>
  <WizardBox title="New Stocktake">
      <template v-slot:tools>
        
      </template>
      <template v-slot:content>
        <FormGroup v-bind:form="stocktakeForm">
          <FormWizard ref="stocktakeWizard" :submitting="submitting" v-bind:tabList="tabList" @finished="handleSubmit">
            <template v-slot:content>
              
              <FormWizardStep index="1" v-bind:active="true">
                <FormRow label="Stocktake Name"><FormInputText placeholder="Stocktake Name" v-model="stocktake.name" field="name" /></FormRow>
              </FormWizardStep>

              <FormWizardStep index="2">
                <TabbedBox>
                  <template v-slot:tablist>
                    <Tab :first="true" tabid="tab-settings-glass">
                      <i class="far fa-container-storage"></i> Glass
                    </Tab>
                    <Tab tabid="tab-settings-general">
                      <i class="far fa-box-up"></i> General
                    </Tab>
                  </template>
                  <template v-slot:tabcontent>
                    <TabPage :first="true" tabid="tab-settings-glass">
                      <ActionDropMenu class="float-right">
                        <DropdownMenuItem @click="enableAllGlass" icon="fa-check">Enable All</DropdownMenuItem>
                        <DropdownMenuItem @click="disableAllGlass" icon="fa-times">Disable All</DropdownMenuItem>
                        <!-- Offcuts disabled until we figure them out
                          <DropdownMenuDivider />
                          <DropdownMenuItem @click="enableAllOffcuts" icon="fa-check">Enable Offcuts</DropdownMenuItem>
                          <DropdownMenuItem @click="disableAllOffcuts" icon="fa-times">Disable Offcuts</DropdownMenuItem>
                        -->
                      </ActionDropMenu>
                      <h3>Glass Stocktake Settings</h3>
                      <CollapsibleTable>
                        <template v-slot:header>
                          <tr>
                            <th>Category</th>
                            <th width="150px">Enabled</th>
                          </tr>
                        </template>
                        <template v-slot:body>
                          <template v-for="(stockCategory, index) in glassStockCategoryList">
                            <CollapsibleRow :key="index">
                              <td class="font-weight-bold" @click="categoryBarClicked($event, stockCategory, true)">
                                <CollapsibleRowArrow :expanded="stockCategory.expanded" />
                                <span :class="{'stocktake-inactive-item' : !stockCategory.isActive }">{{stockCategory.name}}</span>
                              </td>
                              <td @click="categoryBarClicked($event, stockCategory, true)">
                                <FormSwitch 
                                  :value="getSwitchValue(stockCategory)"
                                  @update="categorySwitchUpdated(stockCategory, $event)"
                                />
                              </td>
                            </CollapsibleRow>
                            <template v-for="stock in getStockListForCategory(stockCategory)">
                              <CollapsibleRow :key="`${stock.id}-stock`" v-show="stockCategory.expanded">
                                <td @click="stockBarClicked($event, stock, true)" :class="{'stocktake-inactive-item' : !stock.isActive}">
                                  <span class="ml-3" /><CollapsibleRowArrow :expanded="stock.expanded" />{{stock.name}}
                                </td>
                                <td @click="stockBarClicked($event, stock, true)">
                                  <FormSwitch 
                                    :value="getSwitchValue(stock)"
                                    @update="stockSwitchUpdated(stock, $event)"
                                  />
                                </td>
                              </CollapsibleRow>

                              <template v-for="(glassSize, index) in getGlassSizeListForStock(stock)">
                                <tr :key="`${stock.id}-${index}-glasssize`" class="" v-show="stock.expanded && stockCategory.expanded">
                                  <td :class="{'stocktake-inactive-item' : !glassSize.isActive}">
                                    <span class="ml-3" /><span class="ml-3" />
                                    <span v-if="glassSize.isOffcut">Offcuts</span>
                                    <span v-else>{{glassSize.height}} x {{glassSize.width}}</span>
                                  </td>
                                  <td>
                                    <FormSwitch 
                                      :value="getSwitchValue(glassSize)"
                                      @update="glassSizeSwitchUpdated(glassSize, $event)"
                                    />
                                  </td>
                                </tr>
                              </template>
                            </template>
                          </template>
                        </template>
                      </CollapsibleTable>
                    </TabPage>

                    <TabPage tabid="tab-settings-general">
                      <ActionDropMenu class="float-right">
                        <DropdownMenuItem @click="enableAllGeneral" icon="fa-check">Enable All</DropdownMenuItem>
                        <DropdownMenuItem @click="disableAllGeneral" icon="fa-times">Disable All</DropdownMenuItem>
                      </ActionDropMenu>
                      <h3>Glass Stocktake Settings</h3>
                      <CollapsibleTable>
                        <template v-slot:header>
                          <tr>
                            <th>Category</th>
                            <th width="150px">Enabled</th>
                          </tr>
                        </template>
                        <template v-slot:body>
                          <template v-for="(stockCategory, index) in generalStockCategoryList">
                            <CollapsibleRow :key="index">
                              <td class="font-weight-bold" @click="categoryBarClicked($event, stockCategory, true)">
                                <CollapsibleRowArrow :expanded="stockCategory.expanded" />
                                <span :class="{'stocktake-inactive-item' : !stockCategory.isActive }">{{stockCategory.name}}</span>
                              </td>
                              <td @click="categoryBarClicked($event, stockCategory, true)">
                                <FormSwitch 
                                  :value="getSwitchValue(stockCategory)"
                                  @update="categorySwitchUpdated(stockCategory, $event)"
                                />
                              </td>
                            </CollapsibleRow>
                            <template v-for="stock in getStockListForCategory(stockCategory)">
                              <tr :key="`${stock.id}-stock`" v-show="stockCategory.expanded">
                                <td @click="stockBarClicked($event, stock, true)">
                                  <span :class="{'stocktake-inactive-item' : !stockCategory.isActive }"><span class="ml-3" />{{stock.name}}</span>
                                </td>
                                <td>
                                  <FormSwitch 
                                    :value="getSwitchValue(stock)"
                                    @update="stockSwitchUpdated(stock, $event)"
                                  />
                                </td>
                              </tr>
                            </template>
                          </template>
                        </template>
                      </CollapsibleTable>
                    </TabPage>

                  </template>
                </TabbedBox>
              </FormWizardStep>
            </template>
          </FormWizard>
        </FormGroup>
      </template>
    </WizardBox>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import WizardBox from '@/components/wizardBox'
import FormSwitch from '@/components/form/formSwitch.vue'   // Used for setting enum

import { InventoryStockTypes } from '@/store/types'


export default {
  name: 'StockTakeNew',
  mixins: [form],
  components: {
    WizardBox,
  },
  data() {
    return {
      stocktake: {},
      stocktakeForm: {},
      submitting: false,
      loading: false,
      stockCategoryList: [],
      stockList: [],
      glassSizeList: []
    }
  },
  watch: {
  },
  mounted() {
    this.requestData()
  },
  computed: {
    tabList() {
      var output = [{ title: 'Details' }, { title: 'Stock Settings' }]
      return output
    },
    

    glassStockCategoryList() {
      return this.$data.stockCategoryList.filter(stockCategory => stockCategory.stockType == InventoryStockTypes.glass)
    },
    generalStockCategoryList() {
      return this.$data.stockCategoryList.filter(stockCategory => stockCategory.stockType == InventoryStockTypes.general)
    },
    
  },
  methods: {
    handleSubmit() {
    
      this.submitting = true

      // Send all the category / stock / glasssize enabled/disabled data
      let stockSettings = this.$data.stockList.map(stock => {

        var stockSetting = {
         stockId: stock.id,
          isEnabled: stock.display != FormSwitch.ValueSettings.unchecked,
          offcutsEnabled: false
        }

        if(stock.type == InventoryStockTypes.glass) {
          let offcutRow = this.getGlassSizeListForStock(stock).find(size => size.isOffcut)
          if(offcutRow)
            stockSetting.offcutsEnabled = offcutRow.display != FormSwitch.ValueSettings.unchecked

          stockSetting.glassSizeConfig = this.getGlassSizeListForStock(stock)
          .filter(size => !size.isOffcut)
          .map(size => {
            return {
             glassSizeId: size.id,
              isEnabled: size.display != FormSwitch.ValueSettings.unchecked
            }
          })

          // Stock is enabled if any size is set
          stockSetting.isEnabled = stockSetting.glassSizeConfig.filter(size => size.isEnabled).length > 0
        }
        return stockSetting
      })

      var stocktakeData = {
        name: this.stocktake.name,
        stockConfiguration: stockSettings
      }

      this.$apiService.inventoryService.createStocktake(stocktakeData)
      .then(response => {
        this.successToast('Stocktake Created')
        this.$router.push(`/inventory/stocktakes/${response.data.id}`)
      })
      .catch(err => {
        this.$data.stocktakeForm = this.processFormResponse(err)
        this.$refs.stocktakeWizard.displayErrors()
      })
      .finally(() => {
        this.submitting = false
      })
    },

    requestData() {
      this.loading = true

      Promise.all([
        this.$apiService.inventoryService.getStockCategoryList(),
        this.$apiService.inventoryService.getStockList(),
        this.$apiService.inventoryService.getGlassSizeList(),
      ])
      .then(results => {
        // Category list
        this.$data.stockCategoryList = results[0].data.filter(category => {
          return category.stockType == InventoryStockTypes.glass || category.stockType == InventoryStockTypes.general
        }).map(category => {
          return {
            id: category.id,
            name: category.name,
            stockType: category.stockType,
            expanded: false,
            isEnabled: true,
            isActive: category.isActive,
            display: FormSwitch.ValueSettings.checked
          }
        })

        // Stock List
        // Ignore service stock or general stock that does not have trackable quantities
        this.$data.stockList = results[1].data.filter(stock => {
          if(stock.type == InventoryStockTypes.glass)
            return true
          if(stock.type == InventoryStockTypes.general && stock.isTrackingQuantity)
            return true
          return false
        }).map(stock => {
          stock = _.merge(stock, {
            expanded: false,
            isEnabled: true,
            display: FormSwitch.ValueSettings.checked
          })
          return stock
        })

        this.$data.glassSizeList = results[2].data.map(glassSize => {
          return _.merge(glassSize, { isEnabled: true, display: FormSwitch.ValueSettings.checked })
        })

        // Add an 'offcut' settings row for each glass stock
        // Disabled until we figure out how we are handling them, if we even do support them
        /*
        this.$data.stockList.forEach(stock => {
          if(stock.type == InventoryStockTypes.glass) {
            this.$data.glassSizeList.push({
              id: null,
             stockId: stock.id,
              isEnabled: true,
              isOffcut: true,
              isActive: true,
              display: FormSwitch.ValueSettings.checked
            })
          }
        })
        */
      })
      .catch(err => {
      })
      .finally(() => {
        this.loading = false
      })
    },

    getStockListForCategory(category) {
      return this.$data.stockList.filter(stock => stock.stockCategoryId == category.id)
    },
    getGlassSizeListForStock(stock) {
      return this.$data.glassSizeList.filter(glassSize => glassSize.stockId == stock.id && glassSize.isActive)
    },
    categoryBarClicked(evt, category, nameColumn) {
      // Ignore clicks on switches
      if($(evt.target).is(':input') || $(evt.target).is('label'))
        return true

      category.expanded = !category.expanded
      return true
    },
    stockBarClicked(evt, stock, nameColumn) {
      // Ignore clicks on switches
      if($(evt.target).is(':input') || $(evt.target).is('label'))
        return true

      stock.expanded = !stock.expanded
      return true
    },

    getSwitchValue(item) {
      if(!item.display)
        return FormSwitch.ValueSettings.checked

      return item.display
    },
    categorySwitchUpdated(category, value, nested) {

      // Update all children category/stock items
      this.$data.stockList.forEach(stock => {
        if(stock.stockCategoryId != category.id)
          return

        stock.display = value
        stock.isEnabled = (value == FormSwitch.ValueSettings.checked)

        // Update all glass sizes
        this.getGlassSizeListForStock(stock).forEach(size => {
          size.display = value
          size.isEnabled = (value == FormSwitch.ValueSettings.checked)
        })

      })
      if(!nested) {
        this.updateCategoryStates()
        //this.$emit('update', this.$data.priceConfigData)
      }
    },
    updateCategoryStates() {
      // Update the category states if a stock was modified
      // If a category contains child stock/categories in a mixed state, change the state to interminate
      this.$data.stockCategoryList.forEach(item=> {

        var showCount = this.getDisplayStateCount(item.id, FormSwitch.ValueSettings.checked)
        var hideCount = this.getDisplayStateCount(item.id, FormSwitch.ValueSettings.unchecked)

        // Don't change anything if no children
        if(showCount == 0 && hideCount == 0)
          return

        var display = FormSwitch.ValueSettings.unchecked
        if(showCount > 0)
          display = FormSwitch.ValueSettings.checked
        if(showCount > 0 && hideCount > 0)
          display = FormSwitch.ValueSettings.indeterminate

        item.display = display
      })
      // Update the stock states if a glass size was modified
      this.$data.stockList.forEach(stock => {
        var showCount = this.getGlassSizeListForStock(stock).filter(size => size.display == FormSwitch.ValueSettings.checked).length
        var hideCount = this.getGlassSizeListForStock(stock).filter(size => size.display == FormSwitch.ValueSettings.unchecked).length

        if(showCount == 0 && hideCount == 0)
          return

        var display = FormSwitch.ValueSettings.unchecked
        if(showCount > 0)
          display = FormSwitch.ValueSettings.checked
        if(showCount > 0 && hideCount > 0)
          display = FormSwitch.ValueSettings.indeterminate

        stock.display = display
      })
    },
    getDisplayStateCount(parentCategoryId, displayState) {
      var displayCount = 0

      this.$data.stockList.forEach(stock => {
        if(stock.stockCategoryId != parentCategoryId)
          return

        if(stock.display == displayState)
          displayCount++

        // Glass Sizes
        displayCount += this.getGlassSizeListForStock(stock).filter(size => size.display == displayState).length
      })

      return displayCount
    },
    stockSwitchUpdated(stock, value) {
      stock.display = value
      stock.isEnabled = (value == FormSwitch.ValueSettings.checked)

      // Update all glass sizes
      this.getGlassSizeListForStock(stock).forEach(size => {
        size.display = value
        size.isEnabled = (value == FormSwitch.ValueSettings.checked)
      })

      this.updateCategoryStates()
      //this.$emit('update', this.$data.priceConfigData)
    },
    glassSizeSwitchUpdated(glassSize, value) {
      glassSize.display = value
      glassSize.isEnabled = (value == FormSwitch.ValueSettings.checked)

      this.updateCategoryStates()
      //this.$emit('update', this.$data.priceConfigData)
    },

    enableAllGlass() {
      this.$data.stockCategoryList.forEach(category => {
        if(category.stockType != InventoryStockTypes.glass)
          return
        category.display = FormSwitch.ValueSettings.checked
        category.isEnabled = (category.display == FormSwitch.ValueSettings.checked)
      })

      this.$data.stockList.forEach(stock => {
        if(stock.type != InventoryStockTypes.glass)
          return

        stock.display = FormSwitch.ValueSettings.checked
        stock.isEnabled = (stock.display == FormSwitch.ValueSettings.checked)

        this.getGlassSizeListForStock(stock).forEach(size => {
          size.display = stock.display
          size.isEnabled = (size.display == FormSwitch.ValueSettings.checked)
        })
      })
      this.updateCategoryStates()
      //this.$emit('update', this.$data.priceConfigData)
    },
    disableAllGlass() {
      this.$data.stockCategoryList.forEach(category => {
        if(category.stockType != InventoryStockTypes.glass)
          return

        category.display = FormSwitch.ValueSettings.unchecked
        category.isEnabled = (category.display == FormSwitch.ValueSettings.checked)
      })

      this.$data.stockList.forEach(stock => {
        if(stock.type != InventoryStockTypes.glass)
          return

        stock.display = FormSwitch.ValueSettings.unchecked
        stock.isEnabled = (stock.display == FormSwitch.ValueSettings.checked)

        this.getGlassSizeListForStock(stock).forEach(size => {
          size.display = stock.display
          size.isEnabled = (size.display == FormSwitch.ValueSettings.checked)
        })
      })
      this.updateCategoryStates()
      //this.$emit('update', this.$data.priceConfigData)
    },
    enableAllOffcuts() {
      this.$data.stockList.forEach(stock => {
        if(stock.type != InventoryStockTypes.glass)
          return

        this.getGlassSizeListForStock(stock).forEach(size => {
          if(size.isOffcut) {
            size.display = FormSwitch.ValueSettings.checked
            size.isEnabled = (size.display == FormSwitch.ValueSettings.checked)
          }
        })
      })
      this.updateCategoryStates()
    },
    disableAllOffcuts() {
      this.$data.stockList.forEach(stock => {
        if(stock.type != InventoryStockTypes.glass)
          return

        this.getGlassSizeListForStock(stock).forEach(size => {
          if(size.isOffcut) {
            size.display = FormSwitch.ValueSettings.unchecked
            size.isEnabled = (size.display == FormSwitch.ValueSettings.checked)
          }
        })
      })
      this.updateCategoryStates()
    },

    enableAllGeneral() {
      this.$data.stockCategoryList.forEach(category => {
        if(category.stockType != InventoryStockTypes.general)
          return
        category.display = FormSwitch.ValueSettings.checked
        category.isEnabled = (category.display == FormSwitch.ValueSettings.checked)
      })

      this.$data.stockList.forEach(stock => {
        if(stock.type != InventoryStockTypes.general)
          return
        stock.display = FormSwitch.ValueSettings.checked
        stock.isEnabled = (stock.display == FormSwitch.ValueSettings.checked)
      })
      this.updateCategoryStates()
    },
    disableAllGeneral() {
      this.$data.stockCategoryList.forEach(category => {
        if(category.stockType != InventoryStockTypes.general)
          return
        category.display = FormSwitch.ValueSettings.unchecked
        category.isEnabled = (category.display == FormSwitch.ValueSettings.checked)
      })

      this.$data.stockList.forEach(stock => {
        if(stock.type != InventoryStockTypes.general)
          return
        stock.display = FormSwitch.ValueSettings.unchecked
        stock.isEnabled = (stock.display == FormSwitch.ValueSettings.checked)
      })
      this.updateCategoryStates()
    }
  }
};
</script>
